<script lang="ts">
	import Button from '$lib/components/atoms/button/Button.svelte';
	import * as m from '$paraglide/messages';
	import { onDestroy, onMount } from 'svelte';
	import { getMapContext } from 'svelte-maplibre';

	let disableZoomIn = $state(false);
	let disableZoomOut = $state(false);

	const { map } = $derived(getMapContext());

	function zoomIn() {
		map?.zoomIn();
	}

	function zoomOut() {
		map?.zoomOut();
	}

	function updateZoomButtonsDisabledStatus() {
		const zoom = map?.getZoom();
		disableZoomIn = zoom === map?.getMaxZoom();
		disableZoomOut = zoom === map?.getMinZoom();
	}

	onMount(async () => {
		updateZoomButtonsDisabledStatus();
		map?.on('zoomend', updateZoomButtonsDisabledStatus);
	});

	onDestroy(() => {
		map?.off('zoomend', updateZoomButtonsDisabledStatus);
	});
</script>

<div class="relative flex flex-col">
	<Button
		variant="filled"
		color="white"
		size="sm"
		icon="add"
		ariaLabel={m.map_controls__aria_labels__zoom_in()}
		onclick={zoomIn}
		class="rd-t-1 rd-b-0"
		disabled={disableZoomIn}
	/>
	<Button
		variant="filled"
		color="white"
		size="sm"
		icon="remove"
		ariaLabel={m.map_controls__aria_labels__zoom_out()}
		onclick={zoomOut}
		class="rd-t-0 rd-b-1"
		disabled={disableZoomOut}
	/>
</div>
